import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchLocalizaciones,
  createLocalizacion,
  updateLocalizacion,
  deleteLocalizacion,
} from '../api/localizationsService';

export const useLocalizaciones = () => {
  const queryClient = useQueryClient();

  const { data, error, isLoading } = useQuery({
    queryKey: ['localizaciones'],
    queryFn: fetchLocalizaciones,
  });

  const createMutation = useMutation({
    mutationFn: createLocalizacion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['localizaciones'] });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateLocalizacion(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['localizaciones'] });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: deleteLocalizacion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['localizaciones'] });
    },
  });

  return {
    localizaciones: data,
    isLoading,
    error,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
